import AntdAvatar from 'components/Avatar'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import {
  SubTextWrapper,
  TextWrapper,
  Wrapper,
} from 'modules/Drives/DownloadAndUpload/style'
import moment from 'moment'
import React, { useState } from 'react'
import styled from 'styled-components'
const StyledTextWrapper = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: black;
`

const timing = time => {
  let hours, minutes
  // Ensure time is defined before splitting
  if (time) {
    // eslint-disable-next-line no-extra-semi
    ;[hours, minutes] = time.split(':')
  }

  let newHours = parseInt(hours)
  let timeOfDay = 'am'

  if (newHours >= 12) {
    newHours -= 12
    timeOfDay = 'pm'
  }

  if (newHours === 0) {
    newHours = 12
  }
  const formattedTime = `${newHours}:${minutes} ${timeOfDay}`
  return formattedTime
}

const Content = (data, roundName, panelData) => {
  const mode = data => {
    let mode
    if (data === 'EXTERNAL_LINK_1') {
      mode = 'GOOGLE MEET'
    } else if (data === 'OFFLINE') {
      mode = 'OFFLINE'
    } else {
      mode = 'EXTERNAL LINK'
    }
    return mode
  }

  const startDate = moment(data?.interviewersDetails?.[0]?.panelList?.[0]?.startDate).format('DD-MMM-YYYY');
  const endDate = moment(data?.interviewersDetails?.[0]?.panelList?.[0]?.endDate).format('DD-MMM-YYYY');

  const panelList = data?.interviewersDetails?.[0]?.panelList || [];
  const startTime = panelList?.[0]?.startAMPMTime || 'N/A'; // First student's start time
  const endTime = panelList?.[panelList.length - 1]?.endAMPMTime || 'N/A';

  return (
    <>
      <Wrapper>
        <Flex column center alignCenter gap="8px">
          <TextWrapper>Panel Details</TextWrapper>
          <SubTextWrapper>
            {`${mode(data?.interviewersDetails?.[0]?.mode) || 'OFFLINE'} | ` +
              `${
                startDate === endDate ? startDate : `${startDate} - ${endDate}`
              }` +
              ` | ` +
              ` ${startTime} - ${endTime}` +
              ` | ` +
              `${roundName?.toUpperCase()} | ` +
              ` PANEL ${panelData}`}
          </SubTextWrapper>
        </Flex>
      </Wrapper>

      {data?.present?.length > 0 && (
        <Wrapper>
          <Flex column>
            <TextWrapper>Interviewers present </TextWrapper>
            {data?.present?.map((item, index) => {
              return (
                <Flex
                  row
                  key={index + 'interviewPreset'}
                  alignCenter
                  style={{
                    marginTop: '15px',
                    gap: '8px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <AntdAvatar
                    style={{
                      verticalAlign: 'middle',
                    }}
                    src={item.interviewerDetails?.profileUrl}
                    IconName={item.interviewerDetails?.first_name?.split('')[0]}
                    size={35}
                  ></AntdAvatar>
                  <Flex column>
                    <StyledTextWrapper>
                      {item.interviewerDetails?.first_name?.toUpperCase() +
                        ' ' +
                        item.interviewerDetails?.last_name?.toUpperCase()}{' '}
                    </StyledTextWrapper>
                    <SubTextWrapper>
                      {item?.interviewerDetails?.email +
                        (item?.interviewerDetails?.phone_number
                          ? ' | ' + item?.interviewerDetails?.phone_number
                          : '')}
                    </SubTextWrapper>
                  </Flex>
                </Flex>
              )
            })}
          </Flex>
        </Wrapper>
      )}
      {data?.pending?.length > 0 && (
        <Wrapper>
          <Flex column center>
            <TextWrapper>Score update Pending form</TextWrapper>
            {data?.pending?.map((item, index) => {
              return (
                <Flex
                  row
                  key={index + 'scoreUpdate'}
                  alignCenter
                  style={{
                    marginTop: '15px',
                    gap: '8px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <AntdAvatar
                    style={{
                      verticalAlign: 'middle',
                    }}
                    src={item.interviewerDetails?.profileUrl}
                    IconName={item.interviewerDetails?.first_name?.split('')[0]}
                    size={35}
                  ></AntdAvatar>
                  <Flex column>
                    <StyledTextWrapper>
                      {item.interviewerDetails?.first_name?.toUpperCase() +
                        ' ' +
                        item.interviewerDetails?.last_name?.toUpperCase()}{' '}
                    </StyledTextWrapper>
                    <SubTextWrapper>
                      {item?.interviewerDetails?.email +
                        (item?.interviewerDetails?.phone_number
                          ? ' | ' + item?.interviewerDetails?.phone_number
                          : '')}
                    </SubTextWrapper>
                  </Flex>
                </Flex>
              )
            })}
          </Flex>
        </Wrapper>
      )}
    </>
  )
}

const PanelDrawer = ({
  getPanelList,
  driveId,
  roleId,
  roundName,
  panelData,
}) => {
  const [drawerState, setDrawerState] = useState(false)
  const [data, setData] = useState([])

  const onClick = async () => {
    let panelId = panelData
    const { status, data } = await getPanelList({
      roleId,
      driveId,
      roundName,
      panelId,
    })

    if (status >= 200 && status < 300) {
      setDrawerState(true)
      setData(data?.data)
    }
  }
  return (
    <>
      <Button.Secondary
        text={'View Panel Info'}
        height={'38px'}
        onClick={onClick}
        disabled={panelData == 'all'}
      />

      <Drawer
        title="Panel Info"
        width="40%"
        placement="right"
        visible={drawerState}
        content={Content(data, roundName, panelData)}
        onClose={() => {
          setDrawerState(false)
        }}
        closable
      />
    </>
  )
}
export default PanelDrawer
